
import React from "react";
import MainLayout from "@/layout/MainLayout";

const PrivacyPolicy: React.FC = () => {
  return (
    <MainLayout>
      <div className="bg-white min-h-screen text-black">
        <div className="container mx-auto px-6 lg:px-8 py-16">
        <h1 className="text-4xl font-semibold mb-8 text-black">Privacy Policy</h1>
        
        <div className="prose prose-lg max-w-none text-black">
          <p className="mb-4">Last updated: {new Date().toLocaleDateString()}</p>
          
          <h2 className="text-2xl font-medium mb-4 mt-8">1. Introduction</h2>
          <p>
            HeyVail ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and share your personal information when you use our website and services.
          </p>
          
          <h2 className="text-2xl font-medium mb-4 mt-8">2. Information We Collect</h2>
          <p>We collect the following types of information:</p>
          <ul className="list-disc pl-6 mb-4">
            <li><strong>Personal Information:</strong> Name, email address, phone number, and business information when you register or contact us.</li>
            <li><strong>Usage Data:</strong> Information about how you interact with our website, including pages visited and actions taken.</li>
            <li><strong>Communication Data:</strong> Content of messages exchanged between you and our AI assistant.</li>
            <li><strong>Device Information:</strong> IP address, browser type, and operating system.</li>
          </ul>
          
          <h2 className="text-2xl font-medium mb-4 mt-8">3. How We Use Your Information</h2>
          <p>We use your information for the following purposes:</p>
          <ul className="list-disc pl-6 mb-4">
            <li>To provide and improve our services</li>
            <li>To communicate with you about our services</li>
            <li>To personalize your experience</li>
            <li>To analyze usage patterns and optimize our website</li>
            <li>To protect our legal rights and comply with laws</li>
          </ul>
          
          <h2 className="text-2xl font-medium mb-4 mt-8">4. Information Sharing</h2>
          <p>We may share your information with:</p>
          <ul className="list-disc pl-6 mb-4">
            <li>Service providers who help us operate our business</li>
            <li>Professional advisors, such as lawyers and accountants</li>
            <li>Law enforcement or other government entities when required by law</li>
            <li>Potential buyers in the event of a business transaction</li>
          </ul>
          
          <h2 className="text-2xl font-medium mb-4 mt-8">5. Data Security</h2>
          <p>
            We implement appropriate technical and organizational measures to protect your personal information. However, no method of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.
          </p>
          
          <h2 className="text-2xl font-medium mb-4 mt-8">6. Your Rights</h2>
          <p>Depending on your location, you may have the following rights:</p>
          <ul className="list-disc pl-6 mb-4">
            <li>Access to your personal information</li>
            <li>Correction of inaccurate information</li>
            <li>Deletion of your information</li>
            <li>Restriction of processing</li>
            <li>Data portability</li>
            <li>Objection to processing</li>
          </ul>
          
          <h2 className="text-2xl font-medium mb-4 mt-8">7. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.
          </p>
          
          <h2 className="text-2xl font-medium mb-4 mt-8">8. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us at privacy@HeyVail.com.
          </p>
        </div>
      </div>
    </div>
    </MainLayout>
  );
};

export default PrivacyPolicy;
